// import { handleCategoryNavigation } from "./routeFunctions";
import base from "./base";
import wordpress from "./wordpress";
import catalog from "./catalog";
import profile from "./profile";
import checkout from "./checkout";
import notifications from "./notifications";

const routes = [
  {
    path: "/",
    name: "HomeSite",
    meta: {
      site: "site",
      skipCategory: true,
      canonical: "/"
    },
    props: true,
    component: () => import("@/views/HomeSite.vue")
  },
  {
    path: "/spesa-online-app",
    name: "Home",
    meta: {
      site: "ecommerce",
      slug: "spesa-online-app"
    },
    component: () => import("@/views/Home.vue")
  },
  {
    path: "/shop",
    name: "Home",
    meta: {
      site: "ecommerce",
      slug: "spesa-online-app"
    },
    component: () => import("@/views/Home.vue")
  },
  {
    path: "/melaregalo",
    name: "Melaregalo",
    meta: {
      site: "site",
      slug: "melaregalo"
    },
    component: () => import("@/views/catalog/Melaregalo.vue")
  },
  {
    path: "/app",
    name: "HomeApp",
    props: true,
    meta: {
      site: "app",
      slug: "homepage-app"
    },
    component: () => import("@/views/HomeApp.vue")
  },
  ...base,
  ...wordpress,
  ...profile,
  ...notifications,
  ...checkout,
  ...catalog
];

export default routes;
